<template>
  <div class="pickUpOrders">
    <ContentBlock style="padding: 0 10px 84px 10px;">
      <div class="topTitleContainer">
        <div class="flex-item">订单状态
          <el-radio-group v-model="outform.status" @change="getList('init')" style="margin-left: 14px;">
            <el-radio-button v-for="i in executionStatusGroup" :label="i.en" :key="i.en">{{`${i.label}${!['deliveryCount', 'rejectCount', 'cancelCount'].includes(i.en) ? '(' + (i.count || 0) + ')' : ''}`}}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="flex-item" style="margin-top: 10px;">收货状态
          <el-radio-group v-model="outform.receiveStatus" @change="getList('init')" style="margin-left: 14px;">
            <el-radio-button v-for="i in receiveStatusOptions" :label="i.value" :key="'receive-'+i.value">{{`${i.label}${i.value === '1' ? '(' + (i.count || 0) + ')' : ''}`}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <expand-table
        class="content_block"
        ref="expandTable"
        :toolBar="toolBar"
        :showRightToolbar="true"
        :columnList="orderTableColumns"
        :tableData="dataList"
        :expandConfig="expandConfig"
        :pagination.sync="pagination"
        :sortInfo.sync="updateSortInfo"
        @size-change="getList"
        @current-change="getList"
        @sort-change="getList"
        @handleToggleRowExpand="handleToggleRowExpand"
        style="padding: 0;"
      />
    </ContentBlock>
    <el-drawer title="高级筛选" width="400" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="订单编号">
              <el-input placeholder="请输入订单编号" v-model.trim="form.code" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="客户抬头">
              <el-input placeholder="请输入客户抬头" v-model.trim="form.customerName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="订单来源">
              <el-select
                v-model.trim="form.sourceType"
                clearable
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="平台销售" value="1"></el-option>
                <el-option label="订阅销售" value="2"></el-option>
                <el-option label="客户推送" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="开票状态">
              <el-select
                v-model.trim="form.invoiceStatus"
                clearable
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="(item, index) in invoiceStatusOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="收款状态">
              <el-select
                v-model.trim="form.collectionStatus"
                clearable
                placeholder="请选择"
              >
              <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in collectionStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="收货人">
              <el-input
                v-model.trim="form.receiverName"
                clearable
                placeholder="请输入收货人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="收货人手机">
              <el-input
                v-model.trim="form.receiverPhone"
                clearable
                placeholder="请输入收货人手机"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="销售合同">
              <el-input
                v-model.trim="form.contractCode"
                clearable
                placeholder="请输入销售合同"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="备注">
              <el-input
                v-model.trim="form.remark"
                clearable
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="对方单据号">
              <el-input
                v-model.trim="form.outOrderCode"
                clearable
                placeholder="请输入对方单据号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="getList('init')">查询</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { TablePaginationMixin } from '@/components/common/TableWithPagination';
import ExpandTable from '@/components/common/ExpandTable';
import { queryPage, querySaleOrderCount } from '@/api/pickUpOrders';
import { setOrderTableColumns } from './config/index';
import {
  receiveStatusOptions,
  collectionStatusOptions,
  invoiceStatusOptions,
} from '@/model/pickUpOrders';

const executionStatusGroup = [
  {
    label: '全部',
    value: '',
    en: 'allCount',
    count: 0,
  },
  {
    label: '待确认',
    value: '6',
    en: 'waitConfirmCount',
    count: 0,
  },
  {
    label: '待发货',
    value: '1',
    en: 'waitDeliveryCount',
    count: 0,
  },
  {
    label: '部分发货',
    value: '2',
    en: 'partDeliveryCount',
    count: 0,
  },
  {
    label: '已发货',
    value: '3',
    en: 'deliveryCount',
    count: 0,
  },
  {
    label: '已驳回',
    value: '2',
    en: 'rejectCount',
    count: 0,
  },
  {
    label: '已取消',
    value: '4',
    en: 'cancelCount',
    count: 0,
  },
];
export default {
  name: 'PickUpOrders',
  mixins: [TablePaginationMixin],
  components: {
    ExpandTable,
  },
  data () {
    return {
      outform: {
        status: 'allCount',
        receiveStatus: '',
        orderCodeOrCustomerName: '',
      },
      isShow: false,
      isExpand: 1,
      expandConfig: {
        accordion: false,
        lazy: false,
        expandAll: true,
        reserve: true,
      },
      dataList: [],
      form: {
        deliveryStatus: '',
        contractCode: '',
        sourceType: '',
        invoiceStatus: '',
        collectionStatus: '',
        receiverName: '',
        receiverPhone: '',
        code: '',
        outOrderCode: '',
        customerName: '',
        remark: '',
        orderByProperty: '',
        orderByType: '',
      },
      executionStatusGroup,
      receiveStatusOptions,
      collectionStatusOptions,
      invoiceStatusOptions,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  async created () {
    this.getList();
    this.getSaleContractCount();
  },
  computed: {
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入订单编号/客户抬头' style='width:250px;' v-model={this.outform.orderCodeOrCustomerName}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            const icAdvanceSearch = require('@/assets/table/ic_advanceSearch.svg'); // eslint-disable-line no-undef
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            const icRefresh = require('@/assets/table/ic_refresh.svg'); // eslint-disable-line no-undef
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    orderTableColumns () {
      return setOrderTableColumns.call(this);
    },
  },
  methods: {
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getList();
    },
    handleAdvancedSearch () {
      this.isShow = true;
    },
    handleToggleExpand () {
      this.isExpand = this.isExpand === 3 ? 1 : 3;
      this.$nextTick(() => {
        this.$refs.expandTable.$refs.vxeTable.setAllRowExpand(this.isExpand === 1);
      });
    },
    handleToggleRowExpand () {
      let records = this.$refs.expandTable.$refs.vxeTable.getRowExpandRecords();
      if (records && records.length) {
        this.isExpand = records.length === this.dataList.length ? 1 : 2;
      } else {
        this.isExpand = 3;
      }
    },
    handleEmpty () {
      this.form = this.$options.data().form;
      this.outform = this.$options.data().outform;
      this.pagination.currentPage = 1;
    },
    handleReset () {
      this.handleEmpty();
      this.pagination = {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      };

      this.getList();
    },
    getList (type) {
      if (type === 'init') {
        this.pagination = {
          currentPage: 1,
          pageSize: 10,
        };
      }

      let orderBy = [
        {
          orderByProperty: this.form.orderByProperty || 'lastUpdateTime',
          orderByType: this.form.orderByType || 'DESC',
        },
      ];

      // 处理订单状态选中
      const statusOption = {
        status: '',
        deliveryStatus: '',
      };

      if (this.outform.status === 'allCount') {
        statusOption.status = '';
        statusOption.deliveryStatus = '';
      } else if (this.outform.status) {
        const deliveryStatusEn = ['waitDeliveryCount', 'partDeliveryCount', 'deliveryCount'];
        const orderStatusEn = ['waitConfirmCount', 'rejectCount', 'cancelCount'];
        if (orderStatusEn.includes(this.outform.status)) {
          const statusObj = this.executionStatusGroup.find(item => item.en === this.outform.status);
          statusOption.status = statusObj?.value || '';
          statusOption.deliveryStatus = '';
        } else if (deliveryStatusEn.includes(this.outform.status)) {
          const statusObj = this.executionStatusGroup.find(item => item.en === this.outform.status);
          statusOption.deliveryStatus = statusObj?.value || '';
          statusOption.status = '';
          if (statusOption.deliveryStatus === '1') {
            statusOption.status = '3';
          }
        }
      }

      const page = {
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      this.isShow = false;

      queryPage({ ...this.form, ...this.outform, ...statusOption, findOrderGoodsFlag: true, orderBy, ...page, excludeDockingSystem: 'XIAOZI_ERP' }).then(
        ({body}) => {
          this.dataList = (body.list || []);
          this.pagination.total = +body.total || 0;
        },
      );
    },
    getSaleContractCount () {
      querySaleOrderCount({excludeDockingSystem: 'XIAOZI_ERP'}).then(({ body }) => {
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
        }
        for (let v of this.receiveStatusOptions) {
          v.count = body[v.en];
        }
      });
    },
    operate (row) {
      this.$router.push({
        path: '/saas/pickUpOrders/detail',
        query: {
          id: row.id,
          orderCode: row.code,
          tenantId: row.tenantId,
        },
      });
    },
  },
};
</script>
<style scoped lang='scss'>
/deep/ .topTitleContainer {
  min-height: 60px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px 0px #DFE2E8;
  border-radius: 6px 6px 0px 0px;
  // display: flex;
  // align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  padding: 10px;
  .flex-item {
    display: flex;
    align-items: center;
  }
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}
</style>
